module.exports = __webpack_public_path__ + "img/沈祥福@2x.4ae770d8.png";